import React, { useEffect, useRef } from "react";  // Add useRef
import LZString from 'lz-string';
import { useMap } from "react-leaflet";
import L from "leaflet";
import { useDispatch, useSelector } from "react-redux";
import { addArea, setUploaderFlag } from "../../reducers/MapSlice";
import { setFeaturesColumn, setLoadingfeatures } from "../../reducers/PredictionSlice";
import axios from "../../api/axios_client";
import { toast } from "react-toastify";
import { url } from "../../api/axios_client";

function AddGeoJson() {
  const map = useMap();
  const dispatch = useDispatch();
  let fileContent = useSelector((state) => state.mapState.uploadedFileContent);
  if (fileContent === "") {
    const retrievedCompressed = localStorage.getItem('mapFileContent');
    fileContent = LZString.decompress(retrievedCompressed);
  }
  const geoJsonLayerRef = useRef(null);  // Add ref to track the layer

  function convertToBounds(obj) {
    const { _southWest, _northEast } = obj;
    const west = _southWest.lng;
    const east = _northEast.lng;
    const north = _northEast.lat;
    const south = _southWest.lat;
    return [[west, south], [west, north], [east, north], [east, south]];
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!fileContent) return;

        dispatch(setLoadingfeatures(true));

        // Clear existing GeoJSON layers
        if (geoJsonLayerRef.current) {
          map.removeLayer(geoJsonLayerRef.current);
        }

        // Create and add new GeoJSON layer
        const geoJsonLayer = L.geoJSON(fileContent, {
          onEachFeature: (feature, layer) => {
            if (feature.properties) {
              layer.bindPopup(
                Object.entries(feature.properties)
                  .map(([key, value]) => `${key}: ${value}`)
                  .join('<br>')
              );
            }
          }
        }).addTo(map);

        geoJsonLayerRef.current = geoJsonLayer;
        dispatch(setUploaderFlag(true));

        // Get bounds and fit map
        const bounds = geoJsonLayer.getBounds();
        if (bounds.isValid()) {
          map.fitBounds(bounds, { padding: [50, 50] });  // Add padding for better view
        }

        const boundList = convertToBounds(bounds);

        dispatch(addArea({
          polyId: geoJsonLayer._leaflet_id,
          coordinates: fileContent,
        }));

        // Fetch features validation
        if (fileContent !== "") {
          const res = await axios.post(
            `${url}/prediction/feature-validation`,
            { geo: JSON.stringify(fileContent) },
            { headers: { "Content-Type": "application/json" } }
          );
          dispatch(setFeaturesColumn(res.data.data));
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('Failed to process GeoJSON data');
      } finally {
        dispatch(setLoadingfeatures(false));
      }
    };

    fetchData();

    // Cleanup function
    return () => {
      if (geoJsonLayerRef.current) {
        map.removeLayer(geoJsonLayerRef.current);
      }
    };
  }, [fileContent, dispatch, map]);

  return null;
}

export default AddGeoJson;